export class CurrentUserFollowUpModel {
    id: number;
    userName: string;
    isSeen: boolean;
    seenDate: Date | null;
    title: string;
    bodyText: string;
    entityType: string;
    entityId: number;

    constructor(
        id: number,
        userName: string,
        isSeen: boolean,
        seenDate: Date | null,
        title: string,
        bodyText: string,
        entityType: string,
        entityId: number
    ) {
        this.id = id;
        this.userName = userName;
        this.isSeen = isSeen;
        this.seenDate = seenDate;
        this.title = title;
        this.bodyText = bodyText;
        this.entityType = entityType;
        this.entityId = entityId;
    }

    public static fromJson(json: any): CurrentUserFollowUpModel {
        return new CurrentUserFollowUpModel(
            json["id"],
            json["userName"],
            json["isSeen"],
            json["seenDate"],
            json["title"],
            json["bodyText"],
            json["entityType"],
            json["entityId"]
        );
    }
}
